import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';

import { AvatarComponent } from './components/avatar/avatar.component';

/** Component declaration and export array  */
const COMPONENTS: unknown[] = [AvatarComponent];

/**
 * Card module
 */
@NgModule({
  declarations: [COMPONENTS],
  imports: [CommonModule, IconsModule, ImageModule],
  exports: [COMPONENTS],
})
export class AvatarModule {}
